// Map API endpoints here

export default $axios => ({
  getAssignments(
    { type, assignmentId, offerId, dealId = 0, location },
    rootState
  ) {
    const { isPreview = false, isUnregisteredLink = false } =
      rootState?.offer || {}
    const partnerUserId =
      rootState?.partnerUser?.id || rootState?.partnerUser?.partnerUser?.id

    if (!isPreview && !isUnregisteredLink && !partnerUserId) {
      return Promise.reject(
        new Error('partnerUserId is required to load assignments')
      )
    }

    let url;
    if (isPreview)
      url = `/api/preview/modules/assignment/${type}/assignmentId/${assignmentId}/location/${location}?offerId=0&dealId=${dealId}`;
    else if (isUnregisteredLink)
      url = `/api/unregistered/modules/assignment/${type}/assignmentId/${assignmentId}/location/${location}?offerId=0&dealId=${dealId}`;
    else
      url = `/api/partnerUser/${partnerUserId}/modules/assignment/${type}/assignmentId/${assignmentId}/location/${location}?offerId=${offerId}&dealId=${dealId}`;

    return $axios.get(url);
  }
});
